import React from "react";

const CardDropDownList = ({ items, clickHandler, title, ...rest }) => {
  const actionHandler = (e, item) => {
    e.preventDefault();

    clickHandler(item);
  };
  return (
    <div>
      <div className="side-bar category category-md">
        <h5 className="title">{title}</h5>
        <ul className="dropdown-list-menu">
          <li>
            <a href="#" onClick={(e) => actionHandler(e, null)}>
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              All
            </a>
          </li>
          {items ? (
            items.map((item) => {
              return (
                <li key={item._id}>
                  <a href="#" onClick={(e) => actionHandler(e, item)}>
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                    {item.name}
                  </a>
                </li>
              );
            })
          ) : (
            <li>
              <a href="#">
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                No categories found
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default CardDropDownList;
